import React, { useState } from 'react';
import { withRouter } from 'react-router-dom';
import Paper from 'material-ui/Paper';
import Snackbar from 'material-ui/Snackbar';
import environment from '../../lib/RelayUtils';
import * as ConfigurableBlockAdd from './mutations/ConfigurableBlockAdd';
import { ConfigurableBlockForm } from './ConfigurableBlockForm';

const bodyStyle = { backgroundColor: '#ef426f', height: 'auto', lineHeight: '16px', padding: 12, whiteSpace: 'pre-line' };

export const ConfigurableBlockCreate = withRouter(props => {
	const { history, viewer } = props;
	const [snackbarMessage, setSnackbarMessage] = useState(undefined);
	const onSubmit = data => {
		if (data.type === 'listNews') {
			data.config = {
				title: data.config.title,
				linked: data.config.linked.map(item => ({
					id: item.id,
					title: item.title,
					customTitle: item.customTitle || '',
				})),
			};
		}

		ConfigurableBlockAdd.commit(environment, data, (error: ?Error) => {
			if (error) {
				setSnackbarMessage('Ошибка во время сохранения');
			} else {
				setSnackbarMessage('Пользователь успешно создан');
				history.push('/configurable-blocks');
			}
		});
	};

	const handleCloseSnackbar = () => setSnackbarMessage(undefined);

	return (
		<Paper style={{ width: '100%', padding: 16 }}>
			<ConfigurableBlockForm viewer={viewer} isCreation onSubmit={onSubmit} />
			{snackbarMessage && <Snackbar open bodyStyle={bodyStyle} message={snackbarMessage} onRequestClose={handleCloseSnackbar} />}
		</Paper>
	);
});



// WEBPACK FOOTER //
// src/components/configurable-blocks/ConfigurableBlockCreate.js